import { UIConfig } from "@dytesdk/ui-kit";
import { CustomStates } from "../types/dyte";
import { DyteStateListenersUtils } from "./dyte-meeting-listeners";
import { generateConfig } from "@dytesdk/react-ui-kit";
import { SetStates } from "../types/dyte";
import DyteClient from "@dytesdk/web-core";

export function setFullScreenToggleTargetElement({
  config,
  targetElementId,
}: {
  config: UIConfig;
  targetElementId: string;
}) {
  if (config.root && Array.isArray(config.root["div#controlbar-left"])) {
    const fullScreenToggleIndex = config.root["div#controlbar-left"].indexOf(
      "dyte-fullscreen-toggle"
    );
    if (fullScreenToggleIndex > -1) {
      config.root["div#controlbar-left"][fullScreenToggleIndex] = [
        "dyte-fullscreen-toggle",
        {
          variant: "vertical",
          targetElement: document.querySelector(`#${targetElementId}`),
        },
      ];
    }
  }
  [
    "dyte-more-toggle.activeMoreMenu",
    "dyte-more-toggle.activeMoreMenu.md",
    "dyte-more-toggle.activeMoreMenu.sm",
  ].forEach((configElemKey) => {
    const configElem = config?.root?.[configElemKey] as any;
    configElem?.forEach((dyteElemConfigSet: any) => {
      if (dyteElemConfigSet[0] === "dyte-fullscreen-toggle") {
        dyteElemConfigSet[1].targetElement = document.querySelector(
          `#${targetElementId}`
        );
      }
    });
  });
}

export async function setupMeetingConfigs(
  meeting: DyteClient,
  states: CustomStates,
  setStates: SetStates,
  setConfig: (config: UIConfig) => void
) {
  const theme = meeting!.self.config;
  // @ts-ignore
  const { config } = generateConfig(theme, meeting!);

  /**
   * NOTE(ravindra-dyte):
   * Full screen by default requests dyte-meeting/DyteMeeting element to be in full screen.
   * Since DyteMeeting element is not here,
   *  we need to pass dyte-fullscreen-toggle, an targetElementId through config.
   */

  setFullScreenToggleTargetElement({ config, targetElementId: "root" });

  setConfig({ ...config });

  /**
   * NOTE(ravindra-dyte):
   * Add listeners on meeting & self to monitor leave meeting, join meeting and so on.
   * This work was earlier done by DyteMeeting component internally.
   */
  const stateListenersUtils = new DyteStateListenersUtils(
    // @ts-ignore
    () => meeting,
    () => states,
    () => setStates
  );
  stateListenersUtils.addDyteEventListeners();
}
